import { css, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { BASKET_MUTATOR, BasketMutator } from 'components/ordering/order-form/basket-store.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


@customElement('csc-initialize-basket-store')
export class CSCInitializeBasketStore extends LitElement {
  static override styles = css`
    :host {
      display: contents;
    }
  `

  @inject(BASKET_MUTATOR)
  private basketMutator!: BasketMutator

  @property({ type: String, attribute: 'add-to-basket-path' })
  addToBasketPath = 'basket-add-endpoint'

  @property({ type: Number, attribute: 'basket-count' })
  basketCount = 0

  private productsInBasketLoaded: Promise<void> = Promise.resolve()

  override connectedCallback() {
    super.connectedCallback()

    this.productsInBasketLoaded = this.basketMutator.initializeBasketMutator(this.addToBasketPath, this.basketCount)
  }

  override async getUpdateComplete(): Promise<boolean> {
    const result = await super.getUpdateComplete()
    await this.productsInBasketLoaded

    return result
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'csc-initialize-basket-store': CSCInitializeBasketStore
  }
}
